import useRootContext from '../contexts/Root/useRootContext';

const useI18n = () => {
  const { localization } = useRootContext();

  return localization.useReactTranslatorHook();
};

export default useI18n;
